module.exports = __webpack_public_path__ + "static/img/swiper4.3ade610.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/swiper4.jpg
// module id = wggx
// module chunks = 0